<template>
  <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 14 }, }"
    ref="ruleForm" :rules="rules">
    <a-form-model-item prop="name" label="问卷中文名称">
      <a-input placeholder="请输入问卷中文名称" v-model="model.name" />
    </a-form-model-item>
    <a-form-model-item :rules="[{ required: true, message: '请输入内容', validator: dummyValidator }]" label="问卷英文名称">
      <a-input placeholder="请输入问卷英文名称" v-model="model.nameEn" />
    </a-form-model-item>
    <a-form-model-item prop="keywordList" help="输入关键字后，敲击回车键" label="问卷关键词">
      <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择'>
        <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{ item }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item :rules="[{ required: true, message: '请输入内容', validator: dummyValidator }]" label="问卷功能">
      <a-textarea :rows="2" placeholder="请输入问卷功能" v-model="model.useInfo" />
    </a-form-model-item>
    <a-form-model-item :rules="[{ required: true, message: '请输入内容', validator: dummyValidator }]" label="问卷问题数量">
      <a-input-number v-model="model.number" :min="0" style="width: 100%" placeholder="请问卷问题数量" />
    </a-form-model-item>
    <a-form-model-item :rules="[{ required: true, message: '请输入内容', validator: dummyValidator }]" label="预计用时(分钟)">
      <a-input-number v-model="model.useTime" :min="0" style="width: 100%" placeholder="请输入预计用时(分钟)" />
    </a-form-model-item>
    <a-form-model-item prop="scale" label="是否为量表">
      <a-radio-group v-model="model.scale">
        <a-radio-button value="1">是</a-radio-button>
        <a-radio-button value="0">否</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item prop="abb" label="问卷简称">
      <a-input placeholder="请输入问卷简称" v-model="model.abb" />
    </a-form-model-item>
    <a-form-model-item prop="description" label="问卷简要简介">
      <a-textarea :rows="2" placeholder="请输入问卷简要简介" v-model="model.intro" />
    </a-form-model-item>
    <a-form-model-item prop="inputTip" label="问卷引导语">
      <a-textarea :rows="2" placeholder="请输问卷引导语" v-model="model.inputTip" />
    </a-form-model-item>
    <a-form-model-item prop="intro" label="适应症">
      <a-input placeholder="请输入适应症" v-model="model.indications" />
    </a-form-model-item>
    <a-form-model-item prop="intro" label="禁忌症">
      <a-input placeholder="请输入适应症" v-model="model.contraindications" />
    </a-form-model-item>

    <a-form-model-item prop="intro" label="适用年龄范围">
      <a-input placeholder="请输入适用年龄范围" v-model="model.ageRange" />
    </a-form-model-item>
    <a-form-model-item prop="intro" label="适用性别">
      <a-select v-model='model.sexRange' placeholder='请选择'>
        <a-select-option :value='item.value' :key="item.value" v-for="item in sexList">{{ item.text }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item prop="intro" label="测评方式">
      <a-select v-model='model.testType' placeholder='请选择'>
        <a-select-option :value='item.value' :key="item.value" v-for="item in testList">{{ item.text
          }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <!-- <a-form-model-item prop="intro" label="适用性别">
      <a-input placeholder="请输入适用性别" v-model="model.sexRange" />
    </a-form-model-item> -->

    <a-form-model-item label="是否推荐使用访谈方式进行">
      <a-radio-group v-model="model.isVisit">
        <a-radio-button :value="1">是</a-radio-button>
        <a-radio-button :value="0">否</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="是否要求非文盲">
      <a-radio-group v-model="model.isIlliteracy">
        <a-radio-button :value="1">是</a-radio-button>
        <a-radio-button :value="0">否</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import baseRules from '@/constants/baseRules'
export default {
  name: "FormBaseModal",
  props:
    ['model'],
  data() {
    return {
      title: "操作",
      visible: true,
      sexList: [
        { text: '女', value: '0' },
        { text: '男', value: '1' },
        { text: '均可', value: '2' },
      ],
      testList: [
        { text: '自评', value: '0' },
        { text: '他评', value: '1' },
        { text: '均可', value: '2' },
      ],
      rules: {
        name: [baseRules.required],
        //name_en: [baseRules.required],
        code: [baseRules.required],
        useTime: [baseRules.required],
        scale: [baseRules.requiredChange],
        keywordList: [baseRules.requiredChange],
      },
    }
  },  

  methods: {
    keywordChange() {
      this.$set(this.model, 'keyword', this.model.keywordList.join(','))
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    dummyValidator(rule, value, callback) {
      callback();
    },
    checkFormData() {
      let isValid = false
      this.$refs.ruleForm.validate(valid => {
        isValid = valid
      })
      return isValid
    },
  }
}
</script>

<style lang="less" scoped></style>